/* global axios */
import ApiClient from './ApiClient';

class AiAgentDocumentsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  getDocuments(agentBotId) {
    return axios.get(`${this.url}/${agentBotId}/ai_agent_documents`);
  }

  createDocument(agentBotId, data) {
    // If data is FormData (file upload), send as multipart
    if (data instanceof FormData) {
      return axios.post(
        `${this.url}/${agentBotId}/ai_agent_documents`,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    }
    return axios.post(`${this.url}/${agentBotId}/ai_agent_documents`, data);
  }

  deleteDocument(agentBotId, documentId) {
    return axios.delete(
      `${this.url}/${agentBotId}/ai_agent_documents/${documentId}`
    );
  }

  retryDocument(agentBotId, documentId) {
    return axios.post(
      `${this.url}/${agentBotId}/ai_agent_documents/${documentId}/retry`
    );
  }
}

export default new AiAgentDocumentsAPI();
